// extracted by mini-css-extract-plugin
export default {"link":"styles_link__iTwWL","img":"styles_img__c7Xtj"};